export default {
  //API_URL: "http://13.212.202.218:5000",
  // API_URL: 'https://api.kapanda.com',
  // API_URL: 'http://localhost:5003',
  API_URL: 'https://yb-8b0d32c792e1410191e43c977c5c0ac7.ecs.eu-west-3.on.aws',
  API_OAUTH2_URL:
    'https://yb-8b0d32c792e1410191e43c977c5c0ac7.ecs.eu-west-3.on.aws',
  // API_URL: "https://api.jilook.com",
};
